import { Helmet } from "react-helmet";
import Navbar from "../../../../components/Navbar/Navbar";
import WhatsAppWidget from "../../../../components/Navbar/Whatsapp";
import Banner from "../../../../components/body/projectPageComponents/Banner";
import Overview from "../../../../components/body/projectPageComponents/Overview";
import Pricing from "../../../../components/body/projectPageComponents/Pricing";
import Gallery from "../../../../components/body/projectPageComponents/Gallery";
import Location from "../../../../components/body/projectPageComponents/Location";
import Highlights from "../../../../components/body/projectPageComponents/Highlights";
import SiteVisitBanner from "../../../../components/body/projectPageComponents/SiteVisitBanner";
import FloorPlans from "../../../../components/body/projectPageComponents/FloorPlans";
import Amenities from "../../../../components/body/projectPageComponents/Amenities";
import Faq from "../../../../components/body/projectPageComponents/Faq";
import SimilarProject from "../../../../components/body/projectPageComponents/SimilarProject";

import { projectssattva } from "../../../../data/projects/sattva/data";

export const SaatvaForestRidge = () => {
  const {
    forestridge: {
      form_data,
      whatsapp,
      bannerdata,
      overview,
      sitevisit,
      pricing,
      floor_plan,
      highlights,
      location,
      gallery,
      faq,
      similar
    }
  } = projectssattva;

  return (
    <>
      <Helmet>
        <title>Sattva Forest Ridge JP Nagar, Bengaluru – Luxury Apartments with Green Living</title>

        <meta
          name="description"
          content="Explore Sattva Forest Ridge in JP Nagar, Bengaluru, offering premium apartments with lush green surroundings, modern amenities, and excellent connectivity. Book your dream home today!"
        />

        <meta
          name="keywords"
          content="Sattva Forest Ridge, Sattva Forest Ridge JP Nagar, Sattva Forest Ridge Bengaluru, luxury apartments JP Nagar, Sattva JP Nagar Bengaluru, Sattva homes Bengaluru, premium apartments JP Nagar, green living Bengaluru"
        />

        <link
          rel="canonical"
          href="https://propertystation.in/sattva-forest-ridge-jp-nagar-bengaluru"
        />

        <meta
          name="robots"
          content="index, follow"
        />

      </Helmet>

      <WhatsAppWidget whatsappdata={whatsapp} />
      <Navbar />

      <div className="mt-20">
        <Banner
          bannerDesktopImage={bannerdata.bannerDesktopImage}
          bannerMobileImage={bannerdata.bannerMobileImage}
          data={bannerdata.data}
          formData={form_data}
        />
        <Overview overviewData={overview} stripdata={overview.stripdata} />
        <SiteVisitBanner image={sitevisit.image} formData={form_data} />
        <Pricing pricingData={pricing} formData={form_data} />
        <FloorPlans floorPlans={floor_plan} formData={form_data} />
        <Highlights hightlightData={highlights} formData={form_data} />
        <Amenities />
        <Location location={location} />
        <Gallery galleryData={gallery} />
        <Faq faqdata={faq} />
        <SimilarProject Similarprojects={similar} />
      </div>
    </>
  );
};
